// TODO: Remove this file and its imports if unused elsewhere. This file is deprecated
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import ClpSwap from "components/Clp/ClpSwap";
import Footer from "components/Footer/Footer";
import "./BuyClp.css";

import { Trans } from "@lingui/macro";
import { getNativeToken } from "config/tokens";
import { useChainId } from "lib/chains";
import ExternalLink from "components/ExternalLink/ExternalLink";
import { Wrapper } from "../../components/Wrapper/Wrapper";

export default function BuyClp(props) {
  const history = useHistory();
  const [isBuying, setIsBuying] = useState(true);

  useEffect(() => {
    const hash = history.location.hash.replace("#", "");
    setIsBuying(hash !== "redeem");
  }, [history.location.hash]);

  return (
    <Wrapper className="default-container page-layout">
      <ClpSwap {...props} isBuying={isBuying} setIsBuying={setIsBuying} />
    </Wrapper>
  );
}
